import { Injectable } from "@angular/core";
import { API_METHODS, API_URL, OperationType, ROUTE_PATH } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from 'src/environments/environment';
import { RouteEnvelope } from "common/models/utility-models/base-model";
import { GridParams } from "common/models/utility-models/list-utility.model";
import { StudentsModel } from "common/models/page-models/student/formmodel/student-data.model";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
  providedIn: 'root'
})
export class StudentFormDataService extends FormDataService<StudentsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.addStudent, http, ss);
  }

  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.helpGet,
      method: API_METHODS.get
    }
    return edit;
  }


  createInstance(): StudentsModel {
    return new StudentsModel();
  }

  override beforePostData(
      model: any,
      metamodel: any,
      dataModel: any
    ): Promise<StudentsModel> {
      return new Promise((resolve, reject) => {
        // console.log("BEFORE POST DATA MODELLL", model, metamodel, dataModel);
        
        const submitData: any = {};
        console.log(model)
        submitData.first_name = model.first_name;
        submitData.last_name = model.last_name;
        submitData.father_name = model.father_name;
        submitData.mother_name = model.mother_name;
        submitData.mobile_number = model.mobile_number;
        submitData.parentMobileNumber = model.parentMobileNumber;
        submitData.email = model.email;
        submitData.address = model.address;
        submitData.gender = model.gender;
        submitData.age = model.age;
        submitData.state_id = model.state_id;
        submitData.district_id = model.district_id;
        submitData.region_id = model.region_id;
        submitData.name_of_college = model.name_of_college;
        submitData.college_address = model.college_address;
        submitData.branch_id = model.branch_id;
        submitData.batch_id = model.batch_id;
        submitData.unique_batch_id = model.unique_batch_id;
        if(model.profile_pic_path){
          submitData.profile_pic_path = model.profile_pic_path;
        }
        submitData.mentorId = model.mentorId;
        submitData.mentor_email = model.mentor_email;
        submitData.mentor_mobile = model.mentor_mobile;
        submitData.other = model.other;
        submitData.first_year_score = model.first_year_score;
        submitData.first_year2_score = model.first_year2_score;
        submitData.second_year_score = model.second_year_score;
        submitData.second_year2_score = model.second_year2_score;
        submitData.third_year_score = model.third_year_score;
        submitData.third_year2_score = model.third_year2_score;
        submitData.fourth_year_score = model.fourth_year_score;
        submitData.fourth_year2_score = model.fourth_year2_score;
        submitData.first_year_credit = model.first_year_credit;
        submitData.second_year_credit = model.second_year_credit;
        submitData.third_year_credit = model.third_year_credit;
        submitData.fourth_year_credit = model.fourth_year_credit;

        console.log("SUBMIT DATA", submitData);
        resolve(submitData);
      });
    }

    override transformModel(model: any, metamodel?: any): any {
      console.log('Original model:', model);
    
      const formData = new FormData();
    
      for (const key in model) {
        if (model.hasOwnProperty(key)) {
          formData.append(key, model[key]);
        }
      }
    
      // Check if all model keys are present in formData
      const formDataKeys: string[] = [];
      formData.forEach((value, key) => {
        formDataKeys.push(key);
      });
    
      const modelKeys = Object.keys(model);
      const missingKeys = modelKeys.filter(key => !formDataKeys.includes(key));
    
      if (missingKeys.length === 0) {
        console.log('✅ All keys are wrapped inside FormData.');
      } else {
        console.warn('❌ Missing keys in FormData:', missingKeys);
      }
    
      return formData;
    }
    

  // override transformModel(model: any, metamodel?: any): any {
  //   const formData = new FormData();
  
  //   for (const key in model) {
  //     if (model.hasOwnProperty(key)) {
  //       // Check if the key is 'profile_pic_path' or any key you expect the image to be in Base64
  //       if (key === 'profile_pic_path' && model[key].startsWith('data:image')) {
  //         console.log(key);
          
  //         // Convert Base64 to Blob
  //         const base64String = model[key].split(',')[1]; // Remove 'data:image/...;base64,' prefix
  //         const binary = atob(base64String);
  //         const len = binary.length;
  //         const binaryArray = new Uint8Array(len);
          
  //         for (let i = 0; i < len; i++) {
  //           binaryArray[i] = binary.charCodeAt(i);
  //         }
  
  //         // Create Blob and append it to formData
  //         const blob = new Blob([binaryArray], { type: 'image/jpeg' }); // Adjust MIME type if needed
  //         formData.append(key, blob, 'profile_image.jpg'); // Specify filename if desired
  //       } else {
  //         // Append other fields as usual
  //         formData.append(key, model[key]);
  //       }
  //     }
  //   }
  
  //   return formData;
  // }
  

  override async postData(data,isFormData: boolean = true): Promise<any> {
    console.log("POST DATA", data);
    return await super.postData(this.transformModel(data), isFormData);

    // return await new Promise((resolve, reject) => {
    //   const type = this.getOperationType(data);
    //   const url = this.generateUrl(type);
    //   this.apiService
    //     .postData(url, data)
    //     .then((res) => {
    //       if (res.status === 'success') {
    //         this.navigateToTable()
    //       }
    //       resolve(res);
    //     })
    //     .catch((err) => {
    //       reject(err);
    //     });
    // });
  }

  // navigateToTable() {
  //   const envelope = new RouteEnvelope();
  //   envelope.type = OperationType.VIEW;
  //   envelope.transferData = new GridParams();
  //   this.systemService.navigateByUrl(ROUTE_PATH.studentsGrid, envelope);
  // }



}
